import { getLanguageConfigForOutlet } from './outletConfigs';
import { Language, LanguageDetails, OutletLanguageConfig } from './types';

const OUTLET = process.env.OUTLET?.toUpperCase() || '';

export const getAvailableLanguages = (): string[] => {
  if (!OUTLET) {
    throw new Error('OUTLET environment variable is not set');
  }

  switch (OUTLET) {
    case 'IITV':
      return ['fa', 'en', 'ar'];
    case 'AITV':
      return ['fa', 'en', 'pa', 'ar'];
    default:
      throw new Error(`Unsupported outlet: ${OUTLET}`);
  }
};

export const fetchLanguageMetadata = (): Partial<OutletLanguageConfig> => {
  if (!OUTLET) {
    throw new Error('OUTLET environment variable is not set');
  }
  return getLanguageConfigForOutlet(OUTLET);
};

export const getLanguageDetails = (language: Language): LanguageDetails => {
  const metadata = fetchLanguageMetadata()[language];
  if (!metadata) {
    throw new Error(`Unsupported language: ${language}`);
  }
  return metadata;
};